import React from 'react';
import { NavLink } from 'react-router-dom';
import { Luggage, LayoutTemplate, Settings } from 'lucide-react';
import type { CSSProperties } from 'react';
import { sf } from '../../themeConfig/sisuForgeTokens';

const navBarStyle: CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 50,
  backgroundColor: sf.surface,
  borderTop: `1px solid ${sf.border}`,
  boxShadow: `0 -1px 0 rgba(58, 141, 255, 0.06)`,
};

const rowStyle: CSSProperties = {
  margin: '0 auto',
  maxWidth: 560,
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'stretch',
  paddingBottom: 'env(safe-area-inset-bottom, 0px)',
};

const linkBase: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  minHeight: sf.touchMin,
  paddingTop: 8,
  paddingBottom: 8,
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.14em',
  textTransform: 'uppercase' as const,
  textDecoration: 'none',
  fontFamily: sf.fontDisplay,
  textShadow: 'none',
  transition: `color ${sf.transitionFast}, box-shadow ${sf.transitionFast}`,
};

export function BottomNav() {
  return (
    <nav style={navBarStyle} aria-label="Main">
      <div style={rowStyle}>
        <NavLink
          to="/travel-buddy"
          end
          style={({ isActive }) => ({
            ...linkBase,
            color: isActive ? sf.accent : sf.textMuted,
            boxShadow: isActive ? `inset 0 2px 0 ${sf.accent}` : 'none',
          })}
        >
          <Luggage size={22} strokeWidth={2} aria-hidden />
          Trips
        </NavLink>
        <NavLink
          to="/travel-buddy/templates"
          style={({ isActive }) => ({
            ...linkBase,
            color: isActive ? sf.accent : sf.textMuted,
            boxShadow: isActive ? `inset 0 2px 0 ${sf.accent}` : 'none',
          })}
        >
          <LayoutTemplate size={22} strokeWidth={2} aria-hidden />
          Templates
        </NavLink>
        <NavLink
          to="/travel-buddy/settings"
          style={({ isActive }) => ({
            ...linkBase,
            color: isActive ? sf.accent : sf.textMuted,
            boxShadow: isActive ? `inset 0 2px 0 ${sf.accent}` : 'none',
          })}
        >
          <Settings size={22} strokeWidth={2} aria-hidden />
          Settings
        </NavLink>
      </div>
    </nav>
  );
}
